import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OPDLogMst } from '../../../interfaces/masters/opdsequence-mst';
import { OPDSequenceMStApi } from '../api/opdsequence-mst.api';
import { DateService } from '../../../../@theme/components/common/service/date.service';

@Injectable({
  providedIn: 'root'
})
export class AptOpdLogService {

  saveData:OPDLogMst;
  private tenantId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  private userId =parseInt(localStorage.getItem("userId"));
  constructor(private api:OPDSequenceMStApi,public dateobj:DateService) { }
  saveOPDLog(url,status,desc,aptID): Observable<any[]>{
    this.saveData={
      queueStatus: status,
      queueTime: new Date(),
      queueDescription: desc,
      tenantId: this.tenantId,
      branchId: this.branchId,
      appointmentId: aptID,
      createdBy: 1,
      createdDate: new Date(),
      createdIp: null,
      updatedBy: 2,
      updatedDate: null,
      updatedIp: null,
      apptFromDate:this.dateobj.utcFromDate(new Date()),
      apptToDate:this.dateobj.utcToDate(new Date()),
    }
     return this.api.add(url,this.saveData);
  }
}
